const AdditionalContentContext = [
  { key: 'Demo', action: 'demo', title: 'Demo Scan', type: 'video' },
  { key: 'WhatIsBioenergeticTesting', action: 'what-is-bioenergetic-testing', title: 'What is Bioenergetic Testing', type: 'video' },
  { key: 'BioenergeticAnalysisInstructions', action: 'bioenergetic-client-instructions', title: 'Bioenergetic Analysis Resource Guide', type: 'pdf' },
  { key: 'HomeopathicDilutionGuidelines', action: 'dilution-guidelines', title: 'Homeopathic Dilution Guidelines', type: 'pdf' },

];

export default AdditionalContentContext;